/* eslint-disable no-shadow */
import { REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, STUDY_PATHNAME, SOCKET_STATE_CHANGE, SOCKET_MESSAGE } from '../constants/ActionTypes';

export const requestRegister = (user) => ({ user, type: REGISTER_REQUEST });
export const successRegister = (user) => ({ user, type: REGISTER_SUCCESS });
export const failureRegister = (error) => ({ error, type: REGISTER_FAILURE });

export const requestLogin = () => ({ type: LOGIN_REQUEST });
export const successLogin = (user) => ({ user, type: LOGIN_SUCCESS });
export const failureLogin = (error) => ({ error, type: LOGIN_FAILURE });

export const storeStudyPath = (pathname) => ({ type: STUDY_PATHNAME, pathname });
export const connectSocket = (payload) => ({ type: SOCKET_STATE_CHANGE, payload });
export const UpdateSocketMessage = (payload) => ({ type: SOCKET_MESSAGE, payload });

export const requestlogout = () => ({ type: LOGOUT });
